import React, { Component } from "react";

import { CModal, CModalBody, CModalHeader, CLink } from "@coreui/react";

import { friendlyDate } from "../../helpers/date";
import { friendlySize } from "../../helpers/doc";

class InfoModal extends Component {
  render() {
    const { file, show, onClose } = this.props;

    return (
      <CModal
        size="md"
        centered
        show={show}
        onClose={() => onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          Informações sobre {file?.folder ? "a pasta" : "o arquivo"}
        </CModalHeader>
        <CModalBody>
          <p>
            <strong>Nome: </strong>
            {file?.name}
          </p>
          <p>
            <strong>Criado por: </strong>
            <CLink to={`/profile/${file?.user_id}`}>{file?.user_name}</CLink>
          </p>
          {file?.room_id && (
            <p>
              <strong>Sala: </strong>
              <CLink
                to={`/${file.room_class ? "classroom" : "room"}/${
                  file.room_id
                }`}
              >
                {file.room_name}
              </CLink>
            </p>
          )}
          {!file?.folder && (
            <p>
              <strong>Tamanho: </strong>
              {friendlySize(file?.size)}
            </p>
          )}
          <p>
            <strong>Data de criação: </strong>
            {friendlyDate(file?.created_at)}
          </p>
          <p>
            <strong>Última atualização: </strong>
            {friendlyDate(file?.updated_at)}
          </p>
        </CModalBody>
      </CModal>
    );
  }
}

export default InfoModal;
